import cn from 'classnames'
import moment from 'moment'
import Image from 'next/image'
import React from 'react'
import { ISolutionArticleFragment, Maybe } from 'src/graphql/generated/hooks'
import { useDefaultLogo } from 'src/hooks/useDefaultLogo'

export interface ArticleItemProps {
  article: Maybe<ISolutionArticleFragment>
  className?: string
}
export const ArticleItem: React.FC<ArticleItemProps> = ({ article, className, ...props }) => {
  const date = article?.date ? moment(article.date).format('MMMM DD, YYYY') : null
  const defaultLogo = useDefaultLogo()
  return (
    <div
      className={cn('flex items-center m-[1rem] rounded-[1rem] border border-mist cursor-pointer', className)}
      {...props}
    >
      <div className="flex flex-row items-center w-full h-full">
        <div className="w-1/4 h-full flex items-center justify-center">
          {article?.image?.data?.attributes?.url ? (
            <Image
              className="bg-white rounded-l-[1rem] mr-[1rem] object-cover box-border"
              src={article?.image?.data?.attributes?.url}
              priority
              alt=""
              width="118"
              height="88"
              sizes="33vw"
              style={{ height: '120px' }}
            />
          ) : (
            <Image
              className="bg-white rounded-l-[1rem] mr-[1rem] p-[16px] box-border"
              src={defaultLogo}
              priority
              alt=""
              width="118"
              height="88"
            />
          )}
        </div>
        <div className="flex flex-col font-primary font-regular p-1 pr-2 justify-between w-3/4">
          {article?.title && <p className="text-[1.125rem] text-darkgray line-clamp-2 h-[60px]">{article.title}</p>}
          <div className="flex flex-wrap mb-1">
            {article?.publishedBy && (
              <div className="mr-[0.25rem] cursor-pointer font-medium">{article?.publishedBy}</div>
            )}
            |{date && <div className="ml-[0.25rem] font-medium">{date}</div>}
          </div>
        </div>
      </div>
    </div>
  )
}
